module.exports = __webpack_public_path__ + "img/codeMorImg.3d631d7c.jpg";